import { GridColumnType } from "../../../data/gridColumnType";

export const AttendanceTableConfig = {
  columns: [
    {
      name: "Course Provider Name",
      fieldName: "courseProviderName",
      colType: GridColumnType.Text,
    },
    {
      name: "Course Event Name",
      fieldName: "courseEventName",
      colType: GridColumnType.Text,
    },
    {
      name: "Event Date",
      fieldName: "createdAt",
      allowShort: false,
      colType: GridColumnType.DATE,
      colSettings: {
        format: "DD MMM YYYY",
      },
    },
    {
      name: "Uploaded Date",
      fieldName: "attendanceSubmittedDate",
      allowShort: false,
      colType: GridColumnType.DATE,
      colSettings: {
        format: "DD MMM YYYY",
      },
    },
    {
      name: "Status",
      fieldName: "status",
      colType: GridColumnType.Text,
    },
    {
      name: "Action",
      colType: GridColumnType.ACTION,
      defaultAction: {
        allowEdit: false,
        allowDelete: false
      },
      customAction: [
        {
            name: "View",
            
        },
    ],
    },
  ],
};
